import { gql } from 'urql';

export const ASISTENCIA_FIELDS = gql`
  fragment AsistenciaFields on Asistencia {
    id
    empleadoId
    empleadoNombre
    sucursalId
    sucursalNombre
    fecha
    checkIn
    checkOut
    metodo
    lat
    lng
    estado
    notas
  }
`;

export const ASISTENCIAS_LIST = gql`
  query AsistenciasList($filters: AsistenciasFiltersInput, $pagination: PaginationInput, $order: AsistenciaOrderInput) {
    asistencias(filters: $filters, pagination: $pagination, order: $order) {
      total
      summary {
        totalHoras
        llegadasTarde
        ausencias
      }
      pageInfo {
        page
        perPage
        totalItems
        totalPages
      }
      items {
        ...AsistenciaFields
      }
    }
  }
  ${ASISTENCIA_FIELDS}
`;

export const ASISTENCIA_BY_ID = gql`
  query AsistenciaById($id: ID!) {
    asistencia(id: $id) {
      ...AsistenciaFields
    }
  }
  ${ASISTENCIA_FIELDS}
`;

export const ASISTENCIA_CREATE = gql`
  mutation AsistenciaCreate($input: AsistenciaInput!) {
    asistenciaCreate(input: $input) {
      ...AsistenciaFields
    }
  }
  ${ASISTENCIA_FIELDS}
`;

export const ASISTENCIA_UPDATE = gql`
  mutation AsistenciaUpdate($id: ID!, $input: AsistenciaInput!) {
    asistenciaUpdate(id: $id, input: $input) {
      ...AsistenciaFields
    }
  }
  ${ASISTENCIA_FIELDS}
`;

export const ASISTENCIA_DELETE = gql`
  mutation AsistenciaDelete($id: ID!) {
    asistenciaDelete(id: $id)
  }
`;
